export const NOT_STAKING_MVN_TEXT = `You are currently not staking MVN, please stake MVN in order to delegate to a satellite or become your own and take part in the platform’s governance`
